import React, { useState } from 'react'
import CardInfo from './CardInfo'
import { ListDeudaHistorialTable } from './ListDeudaHistorialTable';
import { BackButton } from '../../../../../components/buttons/ButtonDefault';

export const HistorialDeudas = () => {
    const [reload, setReload] = useState(false);
    const [data, setData] = useState(null);
    return (
        <div className='relative'>
            <BackButton />
            <CardInfo
                reload={reload}
                data={data}
                setData={setData}
            />
            <ListDeudaHistorialTable
                reload={reload}
                setReload={setReload}
                dataCard={data}
            />
        </div>
    )
}
